/**
 * Favorites Page
 * ==============
 * Extracted from frontend/favorites/index.blade.php
 *
 * Handles:
 * - removeFavorite() with SweetAlert2 confirmation and axios
 * - downloadFile() delegates to the global window.downloadFile from UIEffects
 *
 * Blade→JS bridge: <script type="application/json" id="favorites-config">
 */

import axios from 'axios';
import { AlertManager } from '../../sweetalert-config.js';

function initFavoritesPage() {
    const configEl = document.getElementById('favorites-config');
    if (!configEl) return; // Not on favorites page

    let config;
    try {
        config = JSON.parse(configEl.textContent);
    } catch (e) {
        console.error('❌ Error parsing favorites-config:', e);
        return;
    }

    const { toggleUrl, downloadUrlBase, locale } = config;
    const isEnglish = locale === 'en';

    /**
     * Remove a file or folder from favorites
     */
    window.removeFavorite = function(id, tipo) {
        tipo = tipo || 'archivo';

        const confirmMessage = tipo === 'carpeta'
            ? (isEnglish ? 'Remove this folder from favorites?' : '¿Quitar esta carpeta de favoritos?')
            : (isEnglish ? 'Remove this file from favorites?' : '¿Quitar este archivo de favoritos?');

        AlertManager.confirm(confirmMessage).then(function(result) {
            if (!result.isConfirmed) return;

            const data = tipo === 'carpeta'
                ? { carpeta_id: id, tipo: 'carpeta' }
                : { archivo_id: id, tipo: 'archivo' };

            axios.post(toggleUrl, data, {
                headers: { 'Accept': 'application/json' }
            })
            .then(function(response) {
                if (response.data.success) {
                    const item = document.querySelector(`[data-tipo="${tipo}"][data-id="${id}"]`);
                    if (item) item.remove();

                    // Reload if no favorites left
                    if (document.querySelectorAll('.fav-row').length === 0) {
                        location.reload();
                    }

                    AlertManager.toast(
                        isEnglish ? 'Removed from favorites' : 'Eliminado de favoritos',
                        'success'
                    );
                }
            })
            .catch(function() {
                AlertManager.toast(
                    isEnglish ? 'Error removing from favorites' : 'Error al quitar de favoritos',
                    'error'
                );
            });
        });
    };

    /**
     * Download a file by ID (favorites page version - creates a hidden link)
     */
    window.downloadFile = function(archivoId) {
        const link = document.createElement('a');
        link.href = downloadUrlBase + '/' + archivoId;
        link.download = '';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    console.log('📋 Favorites page inicializada');
}

document.addEventListener('DOMContentLoaded', initFavoritesPage);
